// Hide unavailable variants
// Sets dropdowns to "Please select..." if no variant exists

document.addEventListener("on:variant:change", (event) => {
  resetAvailability();
  hideNonexistent();

  if (event.detail.variant === null) {
    const dropdowns = document.querySelectorAll(
      "variant-picker .option-selector[data-selector-type='dropdown']"
    );
    let resetFromIndex = -1;

    dropdowns.forEach((dropdown, index) => {
      if (resetFromIndex !== -1) return; // already found the first bad one
      const selectedOption = dropdown.querySelector(
        '.custom-select__option[aria-selected="true"]:not([data-value=""])'
      );
      if (
        selectedOption &&
        (selectedOption.classList.contains('is-unavailable') ||
          selectedOption.classList.contains('is-nonexistent'))
      ) {
        resetFromIndex = index;
      }
    });

    if (resetFromIndex !== -1) {
      dropdowns.forEach((dropdown, index) => {
        if (index >= resetFromIndex) {
          const btnText = dropdown.querySelector('.custom-select__btn .text-start');
          if (btnText) btnText.textContent = 'Please select...';
        }
      });
    }
  }
});

document.addEventListener("DOMContentLoaded", function (event) {
  hideNonexistent();
});

document.addEventListener("on:quickbuy:after-open", (event) => {
  hideNonexistent();

  const callback = (mutationList, observer) => {
    hideNonexistent();
    observer.disconnect();
  };

  const observer = new MutationObserver(callback);

  observer.observe(document.querySelector("quick-add-drawer"), {
    attributes: false,
    childList: true,
    characterData: false,
    subtree: true,
  });
});

const resetAvailability = () => {
  document.querySelectorAll(".custom-select__option").forEach(function (e) {
    e.style.display = "flex";
  });
};

const hideNonexistent = () => {
  document.querySelectorAll(".is-unavailable").forEach(function (e) {
    e.style.display = "none";
  });
  document.querySelectorAll('.custom-select__option[data-value=""]').forEach(function (e) {
    e.style.display = "none";
  });
};
